<!-- Обсуждение пометки через общие компоненты и API комментариев. -->
<template>
  <VehicleRemarkComments
    :comments="remark.comments || []"
    :current-user-id="authorId"
    :is-submitting="store.isSubmitting"
    initially-expanded
    @destroy-comment="store.destroyComment($event.id)"
  >
    <template #form>
      <CommentForm :is-submitting="store.isSubmitting" @submit="submit" />
    </template>
  </VehicleRemarkComments>
</template>
<script>
import VehicleRemarkComments from "@/components/Vehicle/Remark/Comments/List.vue";
import CommentForm from "@/components/Vehicle/Remark/Comments/Form.vue";
import { useFleetVehicleRemarkStore } from "@/stores/fleetVehicleRemarkStore";
export default {
  name: "VehicleRemarkCommentsDiscussion",
  components: { VehicleRemarkComments, CommentForm },
  props: { remark: { type: Object, required: true } },
  computed: {
    store() {
      return useFleetVehicleRemarkStore();
    },
    authorId() {
      return this.store.currentUserId;
    },
  },
  methods: {
    async submit({ payload, resetForm }) {
      await this.store.createComment(this.remark.id, payload);
      resetForm();
    },
  },
};
</script>
